import React, { useState } from "react";
import "./Bitacoras.scss";
import Filtros from "./partes/Filtros";
import Tabla from "./partes/Tabla";
import { getBitacoras } from "./integracion";
import { obtenerMartesYMiercoles } from "../../../utilidades/formateos";


export default function Bitacoras() {
    const [filters, setFilters] = useState({
        id: null,
        desde: obtenerMartesYMiercoles(new Date()).miercolesActual,
        hasta: obtenerMartesYMiercoles(new Date()).martesSiguiente,
        proveedor: { name: 'SUMA TE LLEVA', code: 1 },
        cliente: null,
        ruta: null,
        estructura: null,
        operador: null,
        unidad: null,
    });
    const clean = () => {
        setFilters(
            {
                id: null,
                desde: obtenerMartesYMiercoles(new Date()).miercolesActual,
                hasta: obtenerMartesYMiercoles(new Date()).martesSiguiente,
                proveedor: { name: 'SUMA TE LLEVA', code: 1 },
                cliente: null,
                ruta: null,
                estructura: null,
                operador: null,
                unidad: null,
            }
        )
    }
    const [data, setData] = useState([]);
    // integracion
    const getBitacorasFunc = async () => {
        await getBitacoras(filters, setData)
        // if (filters.id || filters.operador || filters.unidad) {
        // }
        // else if (filters.proveedor) {
        //     await getBitacoras(filters, setData)
        // }
        // else {
        //     Swal.fire({
        //         icon: "error",
        //         text: "Asegúrese de completar los campos Proveedor y Cliente"
        //     })
        // }
    }



    return (
        <div className="pt-2">
            {/* Filtros */}
            <Filtros
                filters={filters}
                setFilters={setFilters}
                onClick={() => { getBitacorasFunc() }}
                onClean={() => { clean()}}
            ></Filtros>

            <Tabla data={data} getBitacorasFunc={getBitacorasFunc}></Tabla>

        </div>
    );
}